module.exports = __webpack_public_path__ + "static/img/kegs-logo-sml.2970b76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kegs-logo-sml.png
// module id = Tqmi
// module chunks = 1